module.exports = __webpack_public_path__ + "img/icon-color-coin.04a3ca76.svg";